import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AudioTranslationPage from './pages/AudioTranslationPage';
import { BlogPage } from './components/BlogPage';
import { CreatorsPage } from './components/CreatorsPage';
import { CookiePolicyPage } from './components/pages/CookiePolicyPage';
import { PrivacyPolicyPage } from './components/pages/PrivacyPolicyPage';
import { TermsOfUsePage } from './components/pages/TermsOfUsePage';
import { LanguageSync } from './components/LanguageSync';
import { CREATORS_LANDING_PATH } from './content/creatorsLanding';
import {
  AUDIO_TRANSLATION_LANDING_PATH,
  DUBBING_LANDING_PATH,
  FREE_CAPTIONS_LANDING_PATH,
  getBasePathFromUrlPath,
  isAudioTranslationPairPath,
  isDubbingPairPath,
} from './utils/localizedRoutes';

function EnglishPrefixRedirect() {
  const location = useLocation();
  const strippedPathname = location.pathname.replace(/^\/en(?=\/|$)/i, '') || '/';
  const target = `${strippedPathname}${location.search}${location.hash}`;
  return <Navigate to={target} replace />;
}

function LocalizedHtmlRouteResolver() {
  const location = useLocation();
  const basePath = getBasePathFromUrlPath(location.pathname);
  const canonicalCookieTarget = `/cookie-policy${location.search}${location.hash}`;
  const canonicalPrivacyTarget = `/privacy/${location.search}${location.hash}`;
  const canonicalTermsTarget = `/terms/${location.search}${location.hash}`;

  if (basePath === '/') {
    return <HomePage />;
  }
  if (basePath === CREATORS_LANDING_PATH) {
    return <CreatorsPage />;
  }
  if (basePath === AUDIO_TRANSLATION_LANDING_PATH) {
    return <AudioTranslationPage />;
  }
  if (basePath === FREE_CAPTIONS_LANDING_PATH) {
    return <HomePage />;
  }
  if (
    basePath === DUBBING_LANDING_PATH ||
    (basePath && isDubbingPairPath(basePath)) ||
    (basePath && isAudioTranslationPairPath(basePath))
  ) {
    return <HomePage />;
  }
  if (basePath === '/blog') {
    return <BlogPage />;
  }
  if (basePath === '/cookie-policy') {
    if (location.pathname !== '/cookie-policy') {
      return <Navigate to={canonicalCookieTarget} replace />;
    }
    return <CookiePolicyPage />;
  }
  if (basePath === '/privacy') {
    if (location.pathname !== '/privacy/') {
      return <Navigate to={canonicalPrivacyTarget} replace />;
    }
    return <PrivacyPolicyPage />;
  }
  if (basePath === '/terms') {
    if (location.pathname !== '/terms/') {
      return <Navigate to={canonicalTermsTarget} replace />;
    }
    return <TermsOfUsePage />;
  }

  return <Navigate to="/" replace />;
}

function ScrollToTopOnRouteChange() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <LanguageSync />
      <ScrollToTopOnRouteChange />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/en/*" element={<EnglishPrefixRedirect />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:articleSlug" element={<BlogPage />} />
        <Route path="*" element={<LocalizedHtmlRouteResolver />} />
      </Routes>
    </BrowserRouter>
  );
}
